import { Component, inject, OnInit } from '@angular/core';
import { environment } from '../../../../../environments/environment';
import { LanguageService } from '../../../../core/services/language/language.service';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-social-links',
  imports: [TranslatePipe],
  templateUrl: './social-links.html',
  styleUrl: './social-links.scss'
})
export class SocialLinks implements OnInit{
  link_now: string = '';
  language = inject(LanguageService);

  ngOnInit(): void {
      this.link_now =  `${environment.linkCabinet}${this.language.appLanguage}/sso/login?service=google&redirect_url=${environment.game}`;
  }

}
